module.exports = __webpack_public_path__ + "img/mirabilite-tours-header.f4fcd26f.png";